import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './modal.module.scss';

const ModalCustom = ({show, onClose, title, component, style}) => {
  return (
    <Modal
      show={show}
      onHide={()=>onClose()}
      dialogClassName={style}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {component}
      </Modal.Body>
    </Modal>
  )
}

export default ModalCustom;
